import { render, staticRenderFns } from "./PropertyHeader.vue?vue&type=template&id=ad863fba&"
import script from "./PropertyHeader.vue?vue&type=script&lang=js&"
export * from "./PropertyHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports